import React, { useEffect, useState } from "react";
import Axios from "../../_services/caller.service";
import styles from "./DiracLicence.module.scss";
import { FiCopy } from "react-icons/fi"; // Importer l'icône de copie
import { toast } from "react-toastify";
import Modal from "../UiComponents/modals/Modal";
import useModal from "../../hooks/useModal";
import { IoMdAddCircleOutline } from "react-icons/io";
import Button from "../UiComponents/Button";
import InputForms from "../UiComponents/forms/InputForms";
import Select from "react-select";
// ... autres imports ...

const DiracLicence = () => {
  const [editRowId, setEditRowId] = useState(null);
  const [formData, setFormData] = useState({});
  const [tableData, setTableData] = useState([]);
  const [newDataList, setNewDataList] = useState([]);
  const [numberOfLines, setNumberOfLines] = useState(1);
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [maj, setMaj] = useState(false);
  const [cabines, setCabines] = useState([]); // État pour stocker les cabines récupérées
  const [selectedUserId, setSelectedUserId] = useState(null); // État pour stocker l'ID de l'utilisateur sélectionné
  const [allCabines, setAllCabines] = useState([]);

  const { isShowing, toggle } = useModal();
  const columnOrder = [
    "ID",
    "CompteHS",
    "cabids",
    "Login",
    "mdp",
    "LicenceKey",
    "reductionCode",
    "Name",
    "Notes",
  ];

  //GET ALL LICENC DIRAC
  useEffect(() => {
    Axios.get("/diracLicence")
      .then((response) => {
        setTableData(response.data.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, [maj]);

  // GET ALL USERS
  useEffect(() => {
    Axios.get("/getAllUserForSuperAdmin")
      .then((response) => {
        setUsers(response.data.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  // EDITION
  const handleEdit = (rowId, rowData) => {
    setEditRowId(rowId);

    // Assurez-vous d'utiliser les données les plus récentes de tableData
    const currentRowData = tableData.find((row) => row.ID === rowData.ID);
    console.log(currentRowData);
    setFormData({
      ...currentRowData,
      cabids: currentRowData.cabids
        .split(",")
        .map((cabId) => parseInt(cabId.trim())),
      CompteHS: currentRowData.CompteHS, // Assurez-vous que c'est le format correct
    });

    // Extraire et définir l'ID de l'utilisateur sélectionné pour la ligne
    const userId = extractUserIdFromCompteHS(currentRowData.CompteHS);
    setSelectedUserId(userId);

    if (!userId) {
      setCabines([]);
    }
  };

  // Fonction pour extraire le userId depuis la valeur CompteHS
  const extractUserIdFromCompteHS = (compteHSValue) => {
    const matches = compteHSValue.match(/\d+$/);
    return matches ? matches[0] : null;
  };

  const getUsedCabines = () => {
    const usedCabines = new Set();
    tableData.forEach((row) => {
      if (row.ID !== formData.ID) {
        // Assurez-vous que les ID sont comparés correctement
        row.cabids.split(",").forEach((cabId) => {
          usedCabines.add(parseInt(cabId.trim())); // Ajouter l'ID après l'avoir converti en nombre
        });
      }
    });

    return usedCabines;
  };

  //GET CABINE USER
  useEffect(() => {
    if (selectedUserId) {
      Axios.get(`/getCabinesIdByCenterAndCabname/${selectedUserId}`)
        .then((response) => {
          const usedCabines = getUsedCabines(); // Obtenir les cabines déjà utilisées
          const availableCabines = response.data.data.filter(
            (cab) => !usedCabines.has(cab.id)
          ); // Filtrer les cabines non utilisées
          setCabines(availableCabines); // Mettre à jour l'état avec les cabines disponibles
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [selectedUserId, tableData]);

  //GET ALL CABINE
  useEffect(() => {
    Axios.get(`/allCabines/`)
      .then((response) => {
        setAllCabines(response.data.data); // Mise à jour de l'état avec les cabines récupérées
      })
      .catch((error) => {
        console.log(error);
      });
  }, []); // Dépendance : ID de l'utilisateur sélectionné

  //UPDATE LES DONNEES DE LA LIGNE LICENCE
  const handleSave = () => {
    const data = formData; // Les données modifiées
    const id = data.id; // L'identifiant de la ligne modifiée
    if (data.cabids && Array.isArray(data.cabids)) {
      // Transformation de la liste des cabids en une chaîne séparée par des virgules
      data.cabids = data.cabids.join(",");
    }

    Axios.put(`/updateDiracLicence/${id}`, data)
      .then((response) => {
        // Trouver l'index de la ligne dans tableData
        const rowIndex = tableData.findIndex((item) => item.id === id);
        if (rowIndex !== -1) {
          // Mise à jour de l'état tableData avec les nouvelles données
          const updatedDataList = tableData.map((item) =>
            item.ID === id ? { ...item, ...data, cabids: data.cabids } : item
          );
          setTableData(updatedDataList);
        }
        toast.success("Modification effectuée avec succès");

        // Réinitialiser l'état d'édition et formData
        setEditRowId(null);
        //setFormData({});
        setMaj(!maj);
      })
      .catch((error) => {
        console.error("Erreur lors de la mise à jour", error);
        toast.error("Erreur lors de la mise à jour");
      });

    // Réinitialiser l'état d'édition
    setEditRowId(null);
  };

  const handleCompteHsChange = (e, key) => {
    setFormData({ ...formData, [key]: e.target.value });

    const matches = e.target.value.match(/\d+$/);
    if (matches && matches.length > 0) {
      const userId = matches[0];
      setSelectedUserId(userId);
    } else {
      toast.error("Aucun numéro trouvé dans la chaîne");
      setSelectedUserId(null);
    }
  };

  const handleInputChange = (e, key) => {
    setFormData({ ...formData, [key]: e.target.value });
  };

  const handleCabineChange = (selectedOptions, key) => {
    const selectedCabines = selectedOptions.map((option) => option.value);
    setFormData({ ...formData, [key]: selectedCabines });
  };

  //COPY COLLE
  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(
      () => {
        toast("Copied to clipboard!");
      },
      (err) => {
        console.error("Could not copy text: ", err);
      }
    );
  };

  //CREATION DE LIGNE VIDE POUR REMPLIR DE NOUVELLE LICENCE
  const submitLines = () => {
    const linesToCreate = Array.from({ length: numberOfLines }, () => ({
      reductionCode: "",
      Name: "",
      Login: "",
      mdp: "",
      LicenceKey: "",
      CompteHS: "",
      cabids: "",
      Notes: "",
    }));

    Axios.post("/createMultipleLicences", { lines: linesToCreate })
      .then((response) => {
        // Mettre à jour l'état tableData avec les nouvelles lignes
        console.log(response.data.newLines);
        const updatedDataList = [...tableData, ...response.data.newLines]; // Assurez-vous que la réponse contient les nouvelles lignes créées
        setTableData(updatedDataList);

        // Réinitialiser l'état d'édition et formData
        setEditRowId(null);
        setFormData({});
        toast.success("Les lignes ont éte crées avec succès");
        toggle();
      })
      .catch((error) => {
        console.error("Erreur lors de la création des lignes", error);
        toast.error("Erreur lors de la création des lignes");
      });
  };

  //OBTENIR LES NOMS DES CABINES PAR LEUR IDS
  const getCabineNamesFromIds = (cabIds) => {
    const ids = cabIds.split(",").map((id) => parseInt(id.trim()));
    const cabineNames = ids.map((id) => {
      const cabine = allCabines.find((cab) => cab.id === id);
      return cabine ? cabine.cabname : "";
    });
    return cabineNames.filter((name) => name !== "").join(", ");
  };

  const filteredData = tableData.filter((row) => {
    // Obtenez les noms des cabines pour la ligne actuelle
    const cabineNamesString = getCabineNamesFromIds(row.cabids);

    // Vérifiez si le terme de recherche est dans CompteHS ou dans la chaîne des noms des cabines
    return (
      row.CompteHS.toLowerCase().includes(searchTerm.toLowerCase()) ||
      cabineNamesString.toLowerCase().includes(searchTerm.toLowerCase())
    );
  });

  return (
    <div className={styles.containerDiracLicence}>
      <div className={styles.containersearchAndButton}>
        <InputForms
          type="text"
          placeholder="Rechercher..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />

        <IoMdAddCircleOutline
          className={styles.iconAddNewMics}
          onClick={() => {
            toggle();
          }}
          style={{ color: "#6d5dfc", fontSize: "50px", cursor: "pointer" }}
        />
      </div>
      <table className={styles.table}>
        <thead>
          <tr>
            {columnOrder.map((colKey) => {
              return (
                <th key={colKey} className={styles.th}>
                  {colKey}
                </th>
              );
            })}
            <th className={styles.th}>Actions</th>{" "}
            {/* En-tête pour les actions */}
          </tr>
        </thead>

        <tbody>
          {filteredData.map((row, index) => (
            <tr key={index}>
              {columnOrder.map((colKey) => {
                const value = row[colKey];
                //SELECT USERS

                if (colKey === "CompteHS" && editRowId === index) {
                  const selectOptions = [
                    { value: "", label: "Aucun utilisateur" },
                    ...users.map((user) => ({
                      value: `${user.user_login} - ${user.ID}`,
                      label: `${user.user_login} - ${user.ID}`,
                    })),
                  ];

                  return (
                    <td key={colKey} className={styles.td}>
                      <Select
                        options={selectOptions}
                        className={styles.selectUser}
                        value={selectOptions.find(
                          (option) => option.value === formData.CompteHS
                        )}
                        onChange={(selectedOption) =>
                          handleCompteHsChange(
                            { target: { value: selectedOption.value } },
                            "CompteHS"
                          )
                        }
                      />
                    </td>
                  );
                }

                // Traitement pour la colonne 'cabids'
                if (colKey === "cabids") {
                  if (editRowId === index) {
                    // En mode édition, afficher le sélecteur Select
                    const cabineOptions = cabines.map((cab) => ({
                      value: cab.id,
                      label: cab.cabname,
                    }));

                    return (
                      <td key={colKey} className={styles.td}>
                        <Select
                          isMulti
                          options={cabineOptions}
                          className={styles.selectCabine}
                          value={cabineOptions.filter((option) =>
                            formData.cabids.includes(option.value)
                          )}
                          onChange={(selectedOptions) =>
                            handleCabineChange(selectedOptions, "cabids")
                          }
                        />
                      </td>
                    );
                  } else {
                    // En mode lecture, afficher les noms des cabines
                    return <td>{getCabineNamesFromIds(row.cabids)}</td>;
                  }
                }
                //COPY CLIP BOARD

                if (["Login", "mdp"].includes(colKey) && editRowId !== index) {
                  return (
                    <td key={colKey} className={styles.td}>
                      <div>
                        {value}
                        <FiCopy
                          onClick={() => copyToClipboard(value)}
                          style={{ cursor: "pointer", marginLeft: "10px" }}
                        />
                      </div>
                    </td>
                  );
                }

                // Si la colonne est 'ID', l'afficher sans input
                if (colKey === "ID") {
                  return (
                    <td key={colKey} className={styles.td}>
                      {value}
                    </td>
                  );
                }

                // Pour les autres colonnes, vérifier si la ligne est en mode édition
                return editRowId === index ? (
                  <td key={colKey} className={styles.td}>
                    <input
                      type="text"
                      className={styles.input}
                      value={formData[colKey]}
                      onChange={(e) => handleInputChange(e, colKey)}
                    />
                  </td>
                ) : (
                  <td key={colKey} className={styles.td}>
                    {value}
                  </td>
                );
              })}
              <td className={styles.td}>
                {editRowId === index ? (
                  <div className={styles.containerBtn}>
                    <button
                      className={styles.button}
                      onClick={() => handleSave(index)}
                    >
                      Save
                    </button>
                    <button
                      className={styles.buttonCancel}
                      onClick={() => {
                        setEditRowId(null);
                        setFormData({});
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                ) : (
                  <button
                    className={styles.button}
                    onClick={() => handleEdit(index, row)}
                  >
                    Edit
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <Modal isShowing={isShowing} hide={toggle}>
        <div className={styles.containerModal}>
          <InputForms
            type="number"
            value={numberOfLines}
            onChange={(e) => setNumberOfLines(e.target.value)}
            placeholder="Nombre de lignes"
          />
          <Button
            onPress={submitLines}
            text={"Générer les lignes"}
            styles={"btnValidation"}
          />

          {/* Afficher les lignes générées */}
          {newDataList.map((line, index) => (
            <div key={index}>
              <span>Ligne {index + 1}</span>
              {/* Afficher les détails de la ligne ou autre traitement */}
            </div>
          ))}
        </div>
      </Modal>
    </div>
  );
};

export default DiracLicence;
